import React, { useCallback } from 'react';
import merge from 'classnames';

import { RadioButton } from '@/components/generic/RadioButton';
import { useOrderDispatch } from '@/components/modals/SubmitOrder/helpers';

import { Props } from './types';

import styles from './ServicesCard.module.scss';

export const ServicesCard = ({ services, selected, disabled }: Props) => {
  const dispatch = useOrderDispatch();
  const handleClick = useCallback(() => {
    if (!disabled) {
      dispatch({
        type: 'UPDATE',
        payload: {
          selectedServices: services.title,
        },
      });
    }
  }, [disabled, dispatch, services.title]);

  return (
    <div
      className={merge(styles.services_card, {
        [styles.services_card_active]: selected,
        [styles.services_card_disabled]: disabled,
      })}
      data-testid="services-card-wrapper"
      onClick={handleClick}
    >
      <div className={styles.header}>
        <div className={styles.radio_group}>
          <RadioButton
            className={merge(styles.radio_button, {
              [styles.radio_button_selected]: selected,
              [styles.radio_button_disabled]: disabled,
            })}
            selected={selected}
          />
          <div>{services.title}</div>
        </div>
      </div>
      <div className={styles.list_wrapper}>
        <ul>
          {services.list.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};
